import axiosInstance from '../../common/axiosInstance';

export function fetchArticle(articleId) {
  return new Promise((resolve, reject) => {
    const payload = {articleId: articleId};
    axiosInstance.post('/article.php', payload)
      .then(response => {
        // response.status, response.statusText, response.headers, response.config 
        if (response?.data) {
          const data = response.data;
          resolve(data);
        } else {
          reject();
        }
      })
      .catch ((err) => {
        console.log('Error', err);
      })
  });
}

export function fetchArticles() {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/articles.php')
      .then(response => {
        if (response?.data) {
          const data = response.data;
          resolve(data);
        } else {
          reject();
        }
      })
      .catch ((err) => {
        console.log('Error', err);
      })
  });
}

export const deleteArticle = (payload) => {

  return new Promise((resolve, reject) => {

    axiosInstance.post('/article-crud.php', payload)
      .then(response => {
        if (response.data && 
            response.data?.success===true && 
            response.data?.delete===true && 
            response.data?.articleId>0) {
          resolve(response.data);
        } else {
          reject(response?.data?.error || 'API error'); 
        }
      })
      .catch(error => {
        reject(error);
      })
  });
}

export const updateArticle = (payload) => {
  return new Promise((resolve, reject) => {

    axiosInstance.post('/article-crud.php', payload)
      .then(response => {
        const { data } = response;
        const { success, update, articleId, error } = data;
        if (success===true && update===true && articleId>0) {
          resolve(data);
        } else if (success===false) {
          reject(error || 'API error');
        } else {
          reject(error || 'API error'); 
        }
      })
      .catch(error => {
        reject(error);
      })
  });
}
